import { render } from "./PessoasRelatorio.vue?vue&type=template&id=309fa056&scoped=true"
import script from "./PessoasRelatorio.vue?vue&type=script&lang=js"
export * from "./PessoasRelatorio.vue?vue&type=script&lang=js"

import "./PessoasRelatorio.vue?vue&type=style&index=0&id=309fa056&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309fa056"]])

export default __exports__